import { MovieStreamAudioMetaFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

export function transformAudio(audioMetas: MovieStreamAudioMetaFragment[]) {
    return audioMetas.map((audioMeta, index) => ({
        audioGroupId: audioMeta.audioGroupId,
        audioChannelsNumber: audioMeta.audioChannelsNumber,
        isForAdult: audioMeta.forAdult,
        title: audioMeta.title || '',
        language: audioMeta.language || '',
        languageName: audioMeta.languageName || '',
        quality: audioMeta.quality || undefined,
        studioName: audioMeta.studioName || undefined,
        visibleByDefault: audioMeta.visibleByDefault,
        index,
    }));
}
